import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { Loading } from '../../Loading/Loading';

export const DashboardIconSubTitle = ({ title, iconClass }) => {
  const intl = useIntl();
  const _ = (id, values) => intl.formatMessage({ id: id }, values);

  return (
    <h2>
      <span className={`dp-dashboard-icon-title ${iconClass}`}></span>
      {_(title)}
    </h2>
  );
};

export const DashboardIconLink = ({ linkTitle, link, id }) => {
  const intl = useIntl();
  const _ = (id, values) => intl.formatMessage({ id: id }, values);
  return (
    <a href={`${link}`} className="dp-dashboard-title-link" id={id}>
      {_(linkTitle)}
    </a>
  );
};

export const KpiGroup = ({ children, loading, disabled, overlay }) => {
  return (
    <div className={`dp-rowflex dp-dashboard-panel ${disabled ? `disabled` : ''}`}>
      {loading && <Loading />}
      {children}
      {disabled && <div className="dp-overlay">{overlay}</div>}
    </div>
  );
};

KpiGroup.propTypes = {
  children: PropTypes.node,
  overlay: PropTypes.node,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
};
